class LocalesApi {
  getTranslations = async (locale: string) => {
    try {
      const response = await fetch(`/translations/${locale}.json`);
      return response.json();
    } catch {
      return null;
    }
  };
}

export default new LocalesApi();
